import { TrialOrderBy } from '@data/sdk/match';

export const SORT_OPTIONS = [
  {
    value: TrialOrderBy.ConfirmedUserTrialCount,
    label: 'confirmed',
  },
  {
    value: TrialOrderBy.PendingUserTrialCount,
    label: 'pending_trial_count',
  },
  {
    value: TrialOrderBy.PotentialUserTrialCount,
    label: 'potential_trial_count',
  },
  {
    value: TrialOrderBy.EligibleUserTrialCount,
    label: 'eligible',
  },
  {
    value: TrialOrderBy.UpdatedAt,
    label: 'updated_at',
  },
  {
    value: TrialOrderBy.Favorite,
    label: 'favorite',
  },
];
